import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { Select } from 'shared/components';

import './IrregularityEntireRoom.scss';

const baseRoom = {
  roomId: undefined,
};

const filterRooms = (rooms, irregRooms, currentId) => {
  if (irregRooms.length < 2) {
    return rooms.map((r) => ({
      value: r.id,
      label: r.name,
    }));
  }

  const filteredRooms = rooms.filter(
    (room) =>
      !irregRooms.find(
        (irregRoom) => +irregRoom.roomId === room.id && +currentId !== +irregRoom.roomId
      )
  );

  return filteredRooms.map((r) => ({
    value: r.id,
    label: r.name,
  }));
};

class IrregularityEntireRoom extends Component {
  constructor(props) {
    super(props);

    baseRoom.irregularityId = props.irregularity.id;

    this.state = { error: '' };

    this.onChange = this.onChange.bind(this);
    this.addRoom = this.addRoom.bind(this);
    this.removeRoom = this.removeRoom.bind(this);
  }

  onChange(e, idx) {
    const { irregularityRooms } = this.props.irregularity;
    irregularityRooms[idx] = {
      roomId: e.target.value,
    };

    this.setState({
      error: '',
    });

    this.props.onChange(irregularityRooms);
  }

  addRoom() {
    const { irregularityRooms } = this.props.irregularity;

    this.setState({
      error: '',
    });

    let haveNames = true;
    if (!irregularityRooms.length) {
      irregularityRooms.push({ error: 'errors.roomNameRequired' });
      haveNames = false;
    }

    irregularityRooms.forEach((room) => {
      if (!room.roomId) {
        room.error = 'errors.roomNameRequired';
        haveNames = false;
      }
    });

    if (!haveNames) {
      this.props.onChange(irregularityRooms);
      return;
    }

    if (irregularityRooms.length === this.props.rooms.length) {
      this.setState({
        error: 'errors.noRoomAvailable',
      });
      return;
    }

    irregularityRooms.push({ ...baseRoom });
    this.props.onChange(irregularityRooms);
  }

  removeRoom(idx) {
    const { irregularityRooms } = this.props.irregularity;
    irregularityRooms.splice(idx, 1);
    this.setState({
      error: '',
    });
    this.props.onChange(irregularityRooms);
  }

  render() {
    const { rooms } = this.props;
    let { irregularityRooms, id } = this.props.irregularity;
    baseRoom.irregularityId = id;
    if (!irregularityRooms || !irregularityRooms.length) {
      irregularityRooms = [baseRoom];
    }

    return (
      <section className="irregularity-entire-room">
        <h6>{this.props.t('irregularities.roomListingLabel')}</h6>

        <div className="irregularity-room-listing">
          {irregularityRooms.map((room, i) => (
            <div className="irregularity-room" key={`room-${room.roomId}`}>
              <Select
                className="w-100"
                options={filterRooms(rooms, irregularityRooms, room.roomId)}
                value={room.roomId}
                name="roomName"
                onChange={(e) => this.onChange(e, i)}
                disabled={this.props.disableRoom}
                errors={room.error}
                emptyDefault
              />
              {i !== 0 && (
                <button className="room-delete" onClick={() => this.removeRoom(i)}>
                  <span>{this.props.t('common.labels.remove')}</span>
                  <div className="remove-icon"></div>
                </button>
              )}
            </div>
          ))}
        </div>
        {this.state.error && (
          <div className="text-error font-size-12">{this.props.t(this.state.error)}</div>
        )}
        {!this.props.disableRoom && (
          <button className="btn btn-small btn-outline ml-0" onClick={this.addRoom}>
            {this.props.t('irregularities.addAdditionalRoomLabel')}
          </button>
        )}
      </section>
    );
  }
}

IrregularityEntireRoom.propTypes = {
  irregularity: PropTypes.shape({
    irregularityRooms: PropTypes.arrayOf(PropTypes.shape({})),
    id: PropTypes.number,
  }).isRequired,
  disableRoom: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};

export default withTranslation()(IrregularityEntireRoom);
